<template>
  <dl
    class="grid grid-cols-2 gap-x-4 gap-y-3 rounded-lg border border-gray-200 bg-white px-4 py-3 md:flex md:flex-wrap md:gap-0 md:p-0"
    data-cy="summary-strip"
  >
    <div
      v-for="item in items"
      :key="item.label"
      class="min-w-0 md:border-l md:border-gray-200 md:px-4 md:py-3 md:first:border-l-0"
      data-cy="summary-item"
      :data-tone="item.tone"
    >
      <dt class="text-sm font-semibold text-gray-900">{{ item.label }}</dt>
      <dd
        class="truncate text-sm"
        :class="item.tone === 'danger' ? 'text-red-600' : 'text-gray-600'"
        :title="display(item.value)"
      >
        {{ display(item.value) }}
      </dd>
    </div>
  </dl>
</template>

<script setup lang="ts">
import { formatCount } from "@/DataImports/importsHubRows";
import type { SummaryItem } from "./types";

defineProps<{ items: SummaryItem[] }>();

function display(value: SummaryItem["value"]): string {
  if (value === null || value === undefined || value === "") return "--";
  return typeof value === "number" ? formatCount(value) : value;
}
</script>
